import Layout, { BreadcrumbItem } from "@/components/layout";
import { ShieldAlert } from "lucide-react";

interface AccessRestrictedProps {
  /** Breadcrumbs for the page the user was denied access to. */
  breadcrumbs: BreadcrumbItem[];
  /** Optional message overriding the default denial copy. */
  message?: string;
}

/**
 * Full-page access denied state for permission-gated pages.
 * @param props - Breadcrumbs and optional denial message
 * @returns The page laid out with a centered access denied card
 */
export default function AccessRestricted({
  breadcrumbs,
  message,
}: AccessRestrictedProps) {
  return (
    <Layout breadcrumbs={breadcrumbs}>
      <div className="flex flex-col items-center justify-center py-20 text-center">
        <ShieldAlert className="h-12 w-12 text-muted-foreground mb-4" />
        <h2 className="text-xl font-semibold mb-2">Access Denied</h2>
        <p className="text-sm text-muted-foreground">
          {message ?? "You don't have permission to view this page."}
        </p>
      </div>
    </Layout>
  );
}
